import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaBell, FaTimes, FaCheckCircle } from 'react-icons/fa';
import { useNotifications } from '../contexts/NotificationContext';

const NotificationPermissionPrompt = () => {
  const { showPermissionPrompt, requestPermission, dismissPermissionPrompt, isSupported } = useNotifications();

  if (!isSupported || !showPermissionPrompt) {
    return null;
  }

  return (
    <AnimatePresence>
      {showPermissionPrompt && (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          className="fixed bottom-4 right-4 left-4 sm:left-auto sm:right-4 sm:w-96 z-50"
        >
          <div className="bg-white rounded-xl shadow-2xl border border-gray-200 p-4 sm:p-5">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <FaBell className="text-blue-600 text-xl" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-bold text-gray-900 mb-1">
                  Enable Notifications
                </h3>
                <p className="text-sm text-gray-600 mb-3">
                  Get instant updates on your order status, exclusive promotions, and special offers!
                </p>
                <div className="space-y-2 text-xs text-gray-500 mb-4">
                  <div className="flex items-center gap-2">
                    <FaCheckCircle className="text-green-500" />
                    <span>Order status updates</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaCheckCircle className="text-green-500" />
                    <span>Exclusive deals & promotions</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaCheckCircle className="text-green-500" />
                    <span>Payment & shipping alerts</span>
                  </div>
                </div>
              </div>
              <button
                onClick={dismissPermissionPrompt}
                className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
              >
                <FaTimes className="text-lg" />
              </button>
            </div>
            <div className="flex gap-2">
              <button
                onClick={dismissPermissionPrompt}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium"
              >
                Maybe Later
              </button>
              <button
                onClick={async () => {
                  await requestPermission();
                }}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-semibold flex items-center justify-center gap-2"
              >
                <FaBell className="text-xs" />
                Enable
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default NotificationPermissionPrompt;

